import { memo } from 'react';
import { useToggle } from '@dfl/hook-utils';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { FlexBox } from '@dfl/mui-react-common';
import { PermissionCheck, useParamsLink } from '@dfl/react-security';
import { useAutoAdjustmentRuleDelete } from '../../hooks/useAutoAdjustmentRuleDelete';
import { IAutoAdjustmentRule } from '../../interfaces/IAutoAdjustmentRule';
import { AUTO_ADJUSTMENT_RULE_PERMISSIONS } from '../../constants/auto-adjustment-rule.permissions';

type AutoAdjustmentRuleActionsProp = {
  rowId: string;
  record: IAutoAdjustmentRule;
};

const AutoAdjustmentRuleActions = ({ rowId }: AutoAdjustmentRuleActionsProp) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const handleEdit = useParamsLink({ edit: rowId });

  const { mutate, isPending, error } = useAutoAdjustmentRuleDelete(rowId, onClose);

  return (
    <FlexBox justifyContent={'center'} alignItems={'center'}>
      <PermissionCheck permissions={AUTO_ADJUSTMENT_RULE_PERMISSIONS.AUTO_ADJUSTMENT_WRITE}>
        <EditRowActions onClick={handleEdit} />
      </PermissionCheck>
      <PermissionCheck permissions={AUTO_ADJUSTMENT_RULE_PERMISSIONS.AUTO_ADJUSTMENT_DELETE}>
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
        />
      </PermissionCheck>
    </FlexBox>
  );
};

export default memo(AutoAdjustmentRuleActions);
